import DialogTitle from '@mui/material/DialogTitle';

export { DialogTitle };
